import { useMemo } from "react";
import { useActionChoices } from "stores";
import { actionInputName } from "components/action-modal/utils/inputName";
import { TASK_INPUT_NAMES } from "constants/action-form";
import { TASKS } from "constants/actions";
import { FormSelectInput } from "form";
import { useActionModalGetContext } from "context/ActionModalProvider";
import { useTranslation } from "react-i18next";

const WateringOperationInput = ({ helperText, isProposed, isViewMode }) => {
  const { t } = useTranslation();
  const { actions } = useActionChoices();
  const { fieldInfo } = useActionModalGetContext();
  const selectedOperationTypeId = fieldInfo.wateringMechanismRead?.id;

  const task = TASKS.watering;
  const taskInputName = TASK_INPUT_NAMES[task];

  const options = useMemo(
    () =>
      actions.watering?.operations?.map(
        ({ operationTypeId, operationTypeName }) => {
          return {
            value: operationTypeId,
            label: operationTypeName,
          };
        },
      ) || [],
    [actions],
  );

  return (
    <FormSelectInput
      name={actionInputName(taskInputName, "operationTypeId", isProposed)}
      value={selectedOperationTypeId}
      placeholder={t("OperationInput.Watering.Placeholder")}
      helperText={helperText}
      shouldHaveErrorBehaviorAfterSubmit
      isDisabled
      isViewMode={isViewMode}
      options={options}
    />
  );
};

export default WateringOperationInput;
